import { isValidFile } from './isValidFile'
import { isWithinSizeLimit } from './isWithinSizeLimit'

/** Sorts files into those the data room takes and the two reasons it refuses the rest. */
export const splitUploadableFiles = (files: File[]): { valid: File[]; unsupported: File[]; oversized: File[] } => {
  const supported = files.filter(isValidFile)
  return {
    valid: supported.filter(isWithinSizeLimit),
    unsupported: files.filter((file) => !isValidFile(file)),
    oversized: supported.filter((file) => !isWithinSizeLimit(file)),
  }
}
